import { Link } from "react-router-dom";
import styles from "./PaymentsTable.module.scss";

interface PaymentsTableProps {
  header: any[];
  rows: any[];
  order: string;
  setOrder: Function;
  setOrderBy: Function;
}

export function PaymentsTable({
  header = [],
  rows = [],
  order,
  setOrder,
  setOrderBy,
}: PaymentsTableProps) {
  const handlePaymentOrder = (order, orderBy) => {
    setOrder(order === "asc" ? "desc" : "asc");
    setOrderBy(orderBy);
  };

  return (
    <div className={`${styles["profile-payments-table"]}`}>
      <table className="table table-hover mb-0">
        <thead>
          <tr>
            {header.map((th: any, i) => (
              <th key={i} scope="col">
                {th.filter ? (
                  <button
                    className={`${styles["filter-btn"]}`}
                    onClick={() => handlePaymentOrder(order, th.order)}
                  >
                    {th.name}&nbsp;
                    {th.filter && (
                      <div
                        className={`${order === "desc" ? styles["up"] : styles["down"]}`}
                      >
                        <i className="icon-chevron-sown"></i>
                      </div>
                    )}
                  </button>
                ) : (
                  th.name
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((br: any, i: number) => (
            <tr key={i}>
              <th scope="row">{br.created_at}</th>
              <td>${br.amount}</td>
              <td>
                {br.podcast ? (
                  br.podcast?.title
                ) : (
                  <>
                    External Podcast:{" "}
                    <a
                      href={br.external_podcast_url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {br.external_podcast_title}{" "}
                    </a>
                  </>
                )}
              </td>
              <td>{br.date_learned}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className={`${styles["load-box"]}`}>
        <Link
          to={"#"}
          className="blue-icon-btn d-flex justify-content-center align-items-center"
        >
          <span>Loading more</span>
          <i className="icon-loading"></i>
        </Link>
      </div>
    </div>
  );
}

export default PaymentsTable;
